export default "__VITE_ASSET__b079585a__"